import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { Product } from '@services/product';
import { Organization } from '@services/organization';
import { Quotation } from '@services/quotation';
import { ParkArea } from '@services/park-area';
import { Site } from '@services/site';

export class QuotationItem extends BaseEntity {
	amount: number; // total price without discount
	numberOfItems: number;
	discount: number;
	organizationId: string;

	@Type(() => Organization)
	organization: Organization;

	quotationId: string;

	// @Type(() => Quotation)
	quotation: Quotation;

	productId: string;

	@Type(() => Product)
	product: Product;

	siteId: string;

	@Type(() => Site)
	site: Site;

	parkAreaId: string;

	@Type(() => ParkArea)
	parkArea: ParkArea;

	checkout?: boolean;

	get productName() {
		return this.product.name;
	}

	get productCategory() {
		return this.product.category;
	}

	get currencySymbol() {
		return this.product.getCurrencySymbol();
	}

	get unitPrice() {
		return this.product.price;
	}

	get productInstallationCost() {
		return this.product.installationCost;
	}

	get totalPriceAfterDiscount() {
		return (this.amount || 0) * (1 - (this.discount || 0));
	}
}
